import {$} from '../jquery-definition.js';

$( function() {
	checkLabelElements();

	$( '[type="checkbox"], [type="radio"]' ).on( 'click', function() {
		checkLabelElements();
	} )
} );

function checkLabelElements() {
	$( '[type="checkbox"], [type="radio"]' ).parents( 'label' ).removeClass( 'checked' );
	$( '[type="checkbox"]:checked, [type="radio"]:checked' ).parents( 'label' ).addClass( 'checked' );
}
